module.exports = "https://static.energy5.com/_next/static/images/commitment-ccb279a7c47caafad1f802308de65c67.png";